import {
  type EventRevisionDto,
  EventRevisionState,
  SourcingEventStatus,
  type SourcingEventDto,
} from "../../../autogen/bff-api";

// Mirrors `SourcingEvent.changesEditWholeEvent` on the BFF — keep the two in step.
export const invitesItsSuppliers = (event: SourcingEventDto): boolean =>
  event.eventContext.type === "Private" || event.eventContext.type === "MiniCompetition";

export const changesEditWholeEvent = invitesItsSuppliers;

export const openChangeDraft = (event: SourcingEventDto): EventRevisionDto | undefined =>
  [...(event.changes ?? [])].reverse().find((c) => c.state === EventRevisionState.Draft);

export const hasChangeInFlight = (event: SourcingEventDto): boolean =>
  (event.changes ?? []).some(
    (c) => c.state === EventRevisionState.Draft || c.state === EventRevisionState.PublicationPending,
  );

export const isEditableInWizard = (event: SourcingEventDto): boolean =>
  event.status === SourcingEventStatus.Draft ||
  (event.status === SourcingEventStatus.Published &&
    changesEditWholeEvent(event) &&
    openChangeDraft(event) !== undefined);
